import React, {useState, useEffect} from "react";

import {BreadCrumbTrail} from "../../../../common/breadcrumb-trail/BreadcrumbTrail";
import topicAreaIcon from "../../../../../resources/images/topic-area-icon.png";
import {BackButton} from "../../../../common/button/back-button/BackButton";
import {NextButton} from "../../../../common/button/next-button/NextButton";
import {CommentToolTip} from "../../../../common/tool-tip-comments/CommentToolTip";
import {ToolTip} from "../../../../common/tool-tip/ToolTip";
import {StandardButton} from "../../../../common/button/standard-button/StandardButton";

export const ProblemOne = ({context, showToaster, setSpinnerText, setContext, navigateTo, navigateBack, toolTipsEnabled}) => {

    const [title, setTitle] = useState(null);
    const [description, setDescription] = useState(null);

    useEffect(() => {
        if (!context.viewMode) {
            setContext((prevState) => ({
                ...prevState,
                breadcrumbs: {
                    ...prevState.breadcrumbs,
                    problemBreadcrumb: {
                        ...prevState.breadcrumbs.problemBreadcrumb,
                        type: "Problem",
                        screenKey: "problemOne",
                    },
                },
            }));
        } else {
            if (!context.copyOfProblemScreen) {
                const copyOfProblemScreen = JSON.stringify(context.problemScreen);
                setContext((prevState) => ({
                    ...prevState,
                    copyOfProblemScreen,
                }));
            }
        }
    }, []);

    useEffect(() => {
        if (context.problemScreen) {
            if (context.problemScreen.title) {
                setTitle(context.problemScreen.title);
            }

            if (context.problemScreen.description) {
                setDescription(context.problemScreen.description);
            }
        }
    }, [context]);

    const handleNextClick = () => {
        setContext((prevState) => ({
            ...prevState,
            problemScreen: {
                ...prevState.problemScreen,
                title,
                description,
            }
        }));
        navigateTo("problemTwo");
    }

    const isButtonDisabled = () => {
        return (!title || title === "" || !description || description === "");
    }

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-left-container">
                    <div className="wizard-icon-container">
                        <img src={topicAreaIcon} alt="Aurum Logo" className="wizard-icon"/>
                    </div>
                    <p className="wizard-icon-label">{context.topicAreaScreen.topicArea.topicArea}</p>
                </div>
                <div className="wizard-right-container">
                    <div className="input-container">
                        <div>
                            <label>Problem Title:</label>
                            {toolTipsEnabled &&
                            <ToolTip tooltipExternalReference={"problemtitle123"}
                                     context={context}
                                     setSpinnerText={setSpinnerText} showToaster={showToaster}
                                     fieldName={"Problem Title:"}/>}
                        </div>
                        <input className="text-input" data-testid="problem-title" onChange={({target}) => {
                            setTitle(target.value)
                        }}
                               disabled={!context.editMode}
                               defaultValue={title ? title : null}/>
                    </div>
                    <div className="input-container">
                        <div>
                            <label>Description of Problem:</label>
                            {toolTipsEnabled &&
                            <ToolTip tooltipExternalReference={"problemdescription123"}
                                     context={context}
                                     setSpinnerText={setSpinnerText} showToaster={showToaster}
                                     fieldName={"Description of Problem:"}/>}
                        </div>
                        <textarea onChange={({target}) => {
                            setDescription(target.value)
                        }}
                                  disabled={!context.editMode}
                                  defaultValue={description ? description : null}
                                  data-testid="description-of-problem"/>
                    </div>
                    {context.viewMode && <div className="back-to-overview-button-container">
                        <StandardButton text="Problem Overview" onClick={() => {
                            navigateTo("problemTree");
                        }}/>
                    </div>}
                    {context.viewMode &&
                    <CommentToolTip contextName={"Problem"} showToaster={showToaster} setSpinnerText={setSpinnerText}
                                    contextExternalReference={context.problemScreen.externalReference}
                                    context={context} toolTipsEnabled={toolTipsEnabled}/>}
                    <div className="navigation-button-container">
                        <NextButton disabled={isButtonDisabled()} onClick={handleNextClick}/>
                        <BackButton onClick={navigateBack}/>
                    </div>
                </div>
            </div>

            <div className="wizard-breadcrumb-container">
                <BreadCrumbTrail context={context} navigateTo={navigateTo}/>
            </div>
        </div>
    );
}
